import { RotateCwIcon, TriangleAlertIcon } from 'lucide-react';
import { Button } from '@/components/button.js';

interface WidgetErrorProps {
  title: string;
  message: string;
  /** Omit to hide the retry button, e.g. an expired link where retrying won't help. */
  onRetry?: () => void;
}

/** Widget-wide failures (config load, connectivity, dead-end links). */
export function WidgetError({ title, message, onRetry }: WidgetErrorProps) {
  return (
    <div className="sm-stack sm-shell">
      <div className="sm-panel sm-stack sm-card sm-card-centered">
        <div className="sm-center sm-badge" data-tone="error">
          <TriangleAlertIcon size={30} strokeWidth={2.5} aria-hidden="true" />
        </div>
        <div className="sm-stack sm-card-intro">
          <h1 className="sm-type-title">{title}</h1>
          <p className="sm-type-body sm-muted">{message}</p>
        </div>
        {onRetry !== undefined ? (
          <div className="sm-stack sm-actions">
            <Button onClick={onRetry} endIcon={<RotateCwIcon size={16} aria-hidden="true" />}>
              Try again
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
